import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/_components/BodyClassController.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeviceIdInit"] */ "/app/components/DeviceIdInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAUpdater"] */ "/app/components/pwa/PWAUpdater.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"300\",\"400\",\"500\",\"700\",\"900\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["DecideProvider"] */ "/app/provider/DecideProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/provider/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/provider/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResponsiveSizeProvider"] */ "/app/provider/useResponsiveSize.tsx");
